import { useEffect, useState } from "react";
import moment from "moment";

import { ReactComponent as RefreshIcon } from "assets/images/iconsV2/refresh-blue.svg";
import { ReactComponent as RefreshDisabledIcon } from "assets/images/iconsV2/refresh-disabled.svg";
import Button from "components/atoms/Button/Button";
import "./RefreshCache.scss";
import { FormattedMessage } from "react-intl";

interface RefreshCacheProps {
  dataUpdatedAt: string | number;
  onRefresh: () => void;
  isLoading?: boolean;
}

export default function RefreshCache({ dataUpdatedAt, onRefresh, isLoading }: RefreshCacheProps) {
  const [timeAgo, setTimeAgo] = useState(moment(dataUpdatedAt).fromNow());

  useEffect(() => {
    // Function to update the time ago string
    const updateTimeAgo = () => {
      setTimeAgo(moment(dataUpdatedAt).fromNow());
    };

    // Set interval to update every minute
    const intervalId = setInterval(updateTimeAgo, 60000);

    // Call the update function initially to set the initial value
    updateTimeAgo();

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, [dataUpdatedAt]);

  return (
    <div className="refresh-cache">
      <p className="m-0 refresh-cache__text">
        <FormattedMessage id="general.lastUpdated" defaultMessage="Last updated" /> {dataUpdatedAt ? timeAgo : "-"}
      </p>
      <Button variant="link" className="refresh-cache__button" onClick={onRefresh} disabled={isLoading}>
        {isLoading ? <RefreshDisabledIcon /> : <RefreshIcon />}
        <p className="m-0 pl-xxs pr-xxs">
          {isLoading ? (
            <FormattedMessage id="general.refreshing" defaultMessage="Refreshing" />
          ) : (
            <FormattedMessage id="general.refresh" defaultMessage="Refresh" />
          )}
        </p>
      </Button>
    </div>
  );
}

RefreshCache.defaultProps = {
  isLoading: false,
};
